import type { SemanticColor } from '@atlaskit/lozenge';

/**
 * Map a third-party **work-item** status (e.g. GitHub issue states) onto the
 * appropriate Atlaskit Lozenge appearance.
 *
 * GitHub returns lower-case statuses such as `"open"` and `"closed"`. Inputs
 * are case-insensitive — callers may pass the value as it comes from the API.
 *
 * Kept separate from `getPullRequestStatusAppearance` so the two domains stay
 * decoupled and additions to either map can't accidentally affect the other.
 */
const workItemStatusToLozengeMap: Record<string, SemanticColor> = {
	OPEN: 'information', // blue
	CLOSED: 'success', // green
};

export const getWorkItemStatusAppearance = (status?: string): SemanticColor =>
	(status ? workItemStatusToLozengeMap[status.toUpperCase()] : undefined) ?? 'neutral';
